/* Wallet preview settings: design names, leather colors and leather textures.
   Edit this file to change how the preview looks. The code that uses it is wallet-preview.js. */
window.PPConfig = {
  /* Heading that replaces Globo's card slot heading (cosmetic only). */
  heading: 'Cardslot Design',

  /* Depth for the wallet's sections, as fractions of the wallet width (leave a part out to turn it off).
       cast   soft shadow each piece casts on what is behind it (pockets, panels, the wallet): dx, dy, blur, opacity.
       A negative dy puts the shadow above each piece's edge (leather stacked on leather).
       rim    darker band under the top edge of each pocket: depth, blur, opacity */
  depth: {
    cast: { dx: 0, dy: -0.006, blur: 0.004, opacity: 0.42 }
  },

  /* Stitching. scale = line thickness as a multiple of the artwork's own line (1.3 is the original; 1.43 is 10%
     thicker). To make it exactly the same on every product instead, use
       thread: { width: 0.004, dash: 1.6, gap: 1.5, shadow: 0.5 }
     width = thickness as a fraction of the wallet width, dash = stitch length and gap = space between stitches
     (both in line widths), shadow = how strongly the thread stands out (0 turns it off).
     Saddle stitching: spi = stitches per inch (3.0 mm irons are about 8.5, 9 here), slant = how far each stitch
     leans from straight across the seam (degrees), length = stitch length in stitch spacings, weight = thread
     thickness in stitch spacings. Each layout's inches is the real width of its artwork (from the product's listed size), which sets the stitch
     spacing. Remove spi to go back to dashed lines. */
  thread: { scale: 1.43, spi: 9, slant: 72, length: 0.62, weight: 0.22, shadow: 0.35 },

  /* Layouts: the pieces of each product that take a leather and color, in the order Globo lists their leather
     choices (the artwork names its pieces the same way). labels renames a piece in the caption under the preview.
     designs (optional) replaces the card slot designs below for that product.
     backOf (optional): { piece: otherPiece } shows otherPiece's leather, a little lighter, on piece until it gets its own color. */
  layouts: {
    squadron: { inches: 9.3, parts: ['exterior', 'interior'] },
    bookmark: { inches: 2, parts: ['body'] },
    passport: { inches: 3.7, parts: ['exterior', 'interior'], backOf: { interior: 'exterior' } },
    harbor: { inches: 6.4,
      parts: ['exterior', 'pocket', 'interior'], labels: { pocket: 'External Pocket' }, designLabel: 'Style',
      designs: [
        { id: 'plain', label: 'No External Pocket', rx: /^no /i },
        { id: 'pocket', label: 'External Pocket', rx: /^external/i }
      ]
    },
    wharf: { inches: 14.7,
      parts: ['exterior', 'interior', 'bifold'], labels: { bifold: 'Bifold Add-On' },
      designs: [
        { id: 'curved', label: 'Curved', rx: /curved/i },
        { id: 'sloping', label: 'Downward Sloping', rx: /slop|downward/i },
        { id: 'straight', label: 'Straight', rx: /straight/i },
        { id: 'cascading', label: 'Cascading', rx: /cascad/i }
      ]
    },
    mariner: { inches: 9.7, parts: ['exterior', 'pocket', 'interior'], labels: { pocket: 'External Pocket' } },
    pod1: { inches: 4, parts: ['body'] },
    reservoir: { inches: 7, parts: ['body', 'snap'], labels: { snap: 'Snap Color' } },
    pod3: { inches: 4,
      parts: ['body', 'cardslot'], labels: { cardslot: 'Cardslot' },
      designs: [
        { id: 'curved', label: 'Curved', rx: /curved/i },
        { id: 'sloping', label: 'Downward', rx: /slop|downward/i },
        { id: 'straight', label: 'Straight', rx: /straight/i }
      ]
    },
    pod5: { inches: 4, parts: ['body', 'middle', 'bottom'], labels: { middle: 'Middle Cardslot', bottom: 'Bottom Cardslot' } },
    pod7: { inches: 4, parts: ['body', 'top', 'middle', 'bottom'], labels: { top: 'Top Cardslot', middle: 'Middle Cardslot', bottom: 'Bottom Cardslot' } }
  },

  /* Card slot designs. rx matches the name of the choice in Globo. */
  designs: [
    { id: 'curved', label: 'Downward', rx: /downward|curved|sloping/i },
    { id: 'straight', label: 'Straight', rx: /straight/i },
    { id: 'scalloped', label: 'Scalloped', rx: /scallop/i },
    { id: 'cascading', label: 'Cascading', rx: /cascad/i }
  ],

  /* Each leather is found by its Globo leather choice (first match wins, so Hatch goes before Buttero).
     palette: color name (lowercase, as in Globo) -> hex. Colors left out use Globo's own swatch color.
     A color can also be { hex, marble: { color, cover, amount } } to add patches of a second color.
     texture: which entry of textures (below) to draw over the color. */
  leathers: {
    hatch: { rx: /hatch/i, texture: 'hatch', palette: 'buttero' },
    buttero: {
      rx: /buttero/i, texture: 'sheen',
      palette: {
        blue: '#2a50a0', bordeaux: '#6a1c2e', chestnut: '#a4552c', green: '#14602f', mahogany: '#77301f',
        red: '#c52a28', violet: '#52308c', whiskey: '#a2622f', yellow: '#f0ac10'
      }
    },
    dollaro: {
      rx: /dollaro/i, texture: 'pebble',
      palette: {
        black: '#3a3738', blue: '#2e4e72', bordeaux: '#6f3a3d', brown: '#6e473f', green: '#2f4f36',
        mahogany: '#6a3a32', natural: '#d9a468', olive: '#565637', orange: '#e5681f', red: '#b23c39',
        taupe: '#856f5d', whiskey: '#a05927', yellow: '#d08a28'
      }
    },
    pueblo: {
      rx: /pueblo/i, texture: 'matte',
      palette: {
        aqua: '#3a8494', black: '#333232', bordeaux: '#7e3a4c', cognac: '#c88a4c', 'dark brown': '#5c4036',
        grey: '#867e72', natural: '#dcbf98', 'navy blue': '#4a5876', olive: '#646a3a', olmo: '#c47a38',
        ortensia: '#3d7c80', pink: '#ec7b75', red: '#d4363a', tobacco: '#7c4e3c', violet: '#66378f',
        walnut: '#8c5a3c', whiskey: '#a8683a', yellow: '#f0a63a'
      }
    },
    cordovan: {
      rx: /cordovan/i, texture: 'gloss',
      palette: {
        black: '#17181c', burgundy: '#6e2a36', cognac: '#8d472a', 'deep blue': '#1f3a82',
        'marbled brown': { hex: '#8a4a22', marble: { color: '#2b150a', cover: 0.4, amount: 0.6 } },
        'marbled turquoise': { hex: '#0e6a68', marble: { color: '#b88a58', cover: 0.36, amount: 0.65 } },
        'natural unglazed': '#d3c4a2', olive: '#5a682b', purple: '#582a78', whiskey: '#a4651a'
      }
    }
  },

  /* Leather textures, drawn as a repeating overlay (and a soft shine) on top of the flat color.
       across    how many grain cells fit across the wallet (bigger = finer grain)
       tile      the repeating grain:
                   pebble  rounded pebbles with soft creases. cells / cellsY = pebbles across and down the tile
                           (more down than across stretches them), angle = direction they run, base and vary =
                           how much pebble sizes differ, crease / dome / relief = how deep they look, soft =
                           how rounded, speck / fine = fine speckle on each pebble, hi = highlight strength
                   matte   soft mottling plus fine grain (scale = size of the soft patches)
                   hatch   fine crosshatch
       shine     soft light-to-dark gradient over the surface: hi = highlight, lo = shadow (0 to 1) */
  textures: {
    pebble: { across: 56, tile: { kind: 'pebble', cells: 44, cellsY: 60, angle: -25, warp: 0.9, width: 0.22, crease: 0.1, tone: 0.02, dome: 0.05, relief: 0.02, soft: 3, speck: 0.03, fine: 240, hi: 0.25, base: 0.75, vary: 0.7, seed: 3 }, shine: { hi: 0.03, lo: 0.08 } },
    matte: { across: 6, tile: { kind: 'matte', scale: 3, fine: 150, mottle: 0.11, grain: 0.08, relief: 0.006, seed: 2 } },
    hatch: { across: 70, tile: { kind: 'hatch', lines: 4, strength: 0.16 }, shine: { hi: 0.06, lo: 0.1 } },
    gloss: { shine: { hi: 0.2, lo: 0.22 } },
    sheen: { shine: { hi: 0.09, lo: 0.12 } }
  }
};
